import { render, staticRenderFns } from "./DefaultLoading.vue?vue&type=template&id=866571fa"
import script from "./DefaultLoading.vue?vue&type=script&lang=js"
export * from "./DefaultLoading.vue?vue&type=script&lang=js"
import style0 from "./DefaultLoading.vue?vue&type=style&index=0&id=866571fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports